// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/fog.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/fog/fog.js';

mount([g0]);
